import { z } from "zod";
import { zGuard } from "../zod/utils.js";

import { EnumValues, McpServerConfigurationType } from "../enums";
import { getNormalEnum } from "../pseudoEnums";
import {
  McpAppCatalog,
  type McpAppCatalogEntry,
  PREDEFINED_MCP_SERVER_NAMES,
} from "./mcpAppCatalog.js";

export const SupportedMcpServerLiteral = z.enum(PREDEFINED_MCP_SERVER_NAMES);
export const SupportedMcpServer = getNormalEnum(SupportedMcpServerLiteral);
export type SupportedMcpServer = EnumValues<typeof SupportedMcpServer>;

export type SupportedMcpServerDetails = Pick<
  McpAppCatalogEntry,
  "description" | "name"
>;

export const SupportedMcpServerDetails: SupportedMcpServerDetails[] =
  McpAppCatalog.map(({ description, name }) => ({
    description,
    name,
  }));

export const isValidSupportedMcpServer = (
  type: McpServerConfigurationType,
  name: string,
): boolean => {
  if (type === McpServerConfigurationType.PRE_DEFINED) {
    return zGuard(SupportedMcpServerLiteral, name);
  }
  return true;
};
